import { AssetProvider } from "../constants/AssetProviderConstants";
import { getPexelsResizedUrl } from "./PexelsUtils";

/**
 * Absolute image keys bypass the media-server prefix. Resizing is the provider's
 * own contract, so it lives with that provider (PexelsUtils) and is dispatched
 * here by the content's `provider`; a second provider adds a branch to
 * getExternalAssetURL.
 */

/**
 * @typedef {import("../constants/AssetProviderConstants").AssetProviderValue} AssetProviderValue
 */

const ABSOLUTE_URL_RE = /^https?:\/\//i;

/**
 * @param {string|undefined|null} key
 * @returns {boolean}
 */
export const isExternalAssetKey = (key) => typeof key === "string" && ABSOLUTE_URL_RE.test(key);

/**
 * @param {string} key
 * @param {number|string} [width] - Non-numeric ops ("file", "preview") return the key as-is.
 * @param {AssetProviderValue} [provider] - The content's `provider`.
 * @returns {string}
 */
export const getExternalAssetURL = (key, width, provider) => {
  if (!isExternalAssetKey(key)) return key;
  if (provider === AssetProvider.PEXELS) return getPexelsResizedUrl(key, width);

  // No resize contract known for this provider.
  return key;
};

export const EXTERNAL_PREVIEW_WIDTH = 400;

/**
 * @param {string} key
 * @param {AssetProviderValue} [provider]
 * @returns {string}
 */
export const getExternalPreviewURL = (key, provider) =>
  getExternalAssetURL(key, EXTERNAL_PREVIEW_WIDTH, provider);

const ExternalAssetUtils = {
  isExternalAssetKey,
  getExternalAssetURL,
  getExternalPreviewURL,
};

export default ExternalAssetUtils;
